import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const adhd = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
